import "./index.scss";

const Footer = () => {
    return (
        <footer className="footer">
            Flip Outlet &copy;{new Date().getFullYear()}
        </footer>
    );
};

export default Footer;
